import { PropsWithChildren } from 'react'
import {
  SvgIcon,
  SvgIconType,
  isFieldVisible,
  Button,
} from '@integration-app/react'

import {
  useEventStopPropagation,
  EventHandlerFunctionType,
} from 'hooks/useEventStopPropagation'

import classes from './AddLevelButton.module.css'
import { NestedLevel } from './NestedLevel'

export function AddLevelButton({
  children,
  field,
  onAdd,
}: PropsWithChildren<{
  field: any
  onAdd: EventHandlerFunctionType
}>) {
  if ((field?.level ?? -1) < 0) {
    return null
  }
  const handleOnAdd = useEventStopPropagation(onAdd)

  if (field?.schema?.type === 'object' && !isFieldVisible(field)) {
    return <RootAddButton onClick={handleOnAdd}>Add Field</RootAddButton>
  }

  if (field?.schema?.type !== 'object' && field.level === 0) {
    return <RootAddButton onClick={handleOnAdd}>Add Field</RootAddButton>
  }

  const buttonText =
    children || field?.name ? `Add field to ${field?.name}` : 'Add Field'

  return (
    <NestedLevel level={field?.level}>
      <div className={classes.addFieldButtonInnerLevel}>
        <AddButton onClick={handleOnAdd}>{buttonText}</AddButton>
      </div>
    </NestedLevel>
  )
}

function RootAddButton({ children, onClick }) {
  return (
    <div className={classes.addFieldButtonRootLevel}>
      <AddButton onClick={onClick}>{children}</AddButton>
    </div>
  )
}

function AddButton({ children, onClick }) {
  return (
    <Button variant={'text'} onClick={onClick}>
      <SvgIcon type={SvgIconType.Add} />
      {children}
    </Button>
  )
}
